<!-- appointment normal checkout -->
<template>
    <div>
        <b-modal
            id="checkOutModal"
            ref="checkOutModal"
            :scrollable="true"
            :lazy="true"
            title-tag="h2"
            title="Check Out"
            no-close-on-backdrop
            @shown="shown"
            @hidden="close"
            :hide-header-close="
                saving &&
                (_.get($refs, 'checkoutForm.is_cc_terminal') ||
                    _.get($refs, 'checkoutForm.is_cc_key_in') ||
                    _.get($refs, 'checkoutForm.is_cc_card_in'))
            "
        >
            <check-out
                v-show="page == 'checkout'"
                ref="checkoutForm"
                :data="checkout_data"
                :app-data="appointment_data"
                :currentPage="page"
                class="pl-2"
                @loading="loading = true"
                @loaded="loading = false"
            />
            <payment
                v-if="page == 'payment'"
                ref="payment"
                :data="checkout_data"
                :metadata="metadata"
                :app-data="appointment_data"
                class="pl-2"
                @loading="loading = true"
                @loaded="loading = false"
                @save="verifyGravityPayment"
                @disableSaveButton="disabledSaveButton"
            />
            <div slot="modal-footer" class="w-100">
                <b-btn
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    @click="$refs.checkOutModal.hide()"
                    >Cancel</b-btn
                >
                <div v-if="loading">
                    <b-btn
                        v-if="
                            _.get(
                                checkout_data,
                                'payment_type_object.name',
                                ''
                            ) == 'Credit Card On Terminal (Gravity)' &&
                            saving &&
                            !cancelling
                        "
                        class="float-left"
                        variant="secondary"
                        @click="cancelOperation"
                        >Cancel
                    </b-btn>
                    <b-btn
                        v-if="
                            _.get(
                                checkout_data,
                                'payment_type_object.name',
                                ''
                            ) == 'Credit Card On Terminal (Stripe)' &&
                            saving &&
                            !cancelling &&
                            stripeTerminal !== null
                        "
                        class="float-left"
                        variant="secondary"
                        @click="resetStripeTerminal"
                        >Cancel
                    </b-btn>
                    <div class="float-right" style="margin-top: 0.5rem;">
                        <span
                            v-if="
                                _.get($refs, 'checkoutForm.is_cc_terminal') &&
                                saving &&
                                !cancelling
                            "
                            >Processing payment</span
                        >
                        <span
                            v-if="
                                _.get($refs, 'checkoutForm.is_cc_terminal') &&
                                cancelling
                            "
                            >Cancelling</span
                        >
                        <img
                            v-if="loading"
                            class="float-right"
                            src="assets/ajax-loader.gif"
                        />
                    </div>
                </div>
                <div v-else class="float-right">
                    <!-- <b-btn variant="primary" @click="save">Save</b-btn> -->
                    <b-btn
                        v-if="page != 'checkout'"
                        variant="primary"
                        @click="back"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        v-if="
                            page == 'checkout' &&
                            _.get($refs, 'checkoutForm.is_cc_key_in')
                        "
                        variant="primary"
                        @click="next"
                        >Next</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'checkout' &&
                            _.get($refs, 'checkoutForm.is_cc_card_in')
                        "
                        variant="primary"
                        @click="showCreditCardDialog"
                        >Next</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'payment' &&
                            _.get($refs, 'checkoutForm.is_gravity_key_in')
                        "
                        id="save-btn"
                        variant="primary"
                        >Check Out</b-btn
                    >
                    <b-btn
                        v-else-if="page == 'payment'"
                        variant="primary"
                        @click="saveCreditCard"
                        :disabled="isDisabledButton"
                        >Check Out</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'checkout' &&
                            _.get($refs, 'checkoutForm.is_stripe_acss')
                        "
                        variant="primary"
                        @click="saveAcssDebitPayment"
                        >Proceed</b-btn
                    >
                    <b-btn
                        v-else
                        :disabled="
                            _.get($refs, 'checkoutForm.is_cc_terminal') &&
                            _.get($refs, 'checkoutForm.is_no_terminal')
                        "
                        variant="primary"
                        @click="save"
                        >Check Out</b-btn
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import CheckOut from "./check-out.vue";
import Payment from "@/module/payment/payment.vue";
import PaymentDialogHelper from "@/module/payment/helper.js";
import CensusMixin from "@/mixins/census";
import PaymentService from "@/services/payment.js";
import PaymentInvoiceSocketMixin from "@/mixins/payment-invoice-socket";
import unsavePrompt from "@/mixins/unsave-prompt.js";

export default {
    name: "CheckOutModal",
    components: {
        CheckOut,
        Payment
    },
    mixins: [
        ScheduleHelper,
        PaymentDialogHelper,
        CensusMixin,
        PaymentInvoiceSocketMixin,
        unsavePrompt
    ],
    props: {
        instanceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            page: "checkout",
            loading: false,
            saving: false,
            cancelling: false,
            open_time: null,
            isDisabledButton: false,
            stripeTerminal: null,
            checkout_data: {
                id: null,
                checkout_date: null,
                invoicesList: [],
                appointment_checked_in: null,
                client_id: null,
                client_email: null,
                client_fax: null,
                credit_amount: 0,
                credits: [],
                change: 1,
                creditsList: [],
                currency_symbol: null,
                documents: [],
                documentsList: [],
                export_message: null,
                invoice_amount: 0,
                invoices: [],
                outstanding_amount: 0,
                payment_amount: 0,
                patient_id: null,
                provider_id: null,
                rabies: {
                    tag: null,
                    record_id: null
                },
                reminder_message: "",
                reminder_note: "",
                payment_type: -1,
                payment_type_object: {},
                paymentTypes: [],
                credit_card_name_on_card: "",
                credit_card_card_number: "",
                credit_card_expiry_month: "",
                credit_card_expiry_year: "",
                credit_card_ccv: "",
                credit_card_processor: "",
                year_options: [],
                save_card: 0,
                anet_transaction_id: "",
                anet_transaction_output: "",
                anet_transaction_name: "",
                payment_id: "",
                terminal: 0,
                terminals: [],
                stripeToken: null,
                payment_method_name: null,
                show_payment_form: 0,
                export_type: 0,
                status: 7,
                signature_cc: null,
                modalWindow: "#checkOutModal",
                checkout_uid: null,
                cardconnect_iframe_url: null,
                module: "appointment",
                cc_iframe_load: false,
                giframe_load: false,
                external_id: "",
                fund_id: null,
                pay_from_fund: 0,
                change_to_fund: 0,
                isSimulator: 0,
                testCardNumber: "",
                includeDeclined: false,
                invoice_with_line_item: false
            },
            appointment_data: {
                id: null,
                start: null,
                end: null,
                checkout_date: null,
                client: null,
                client_id: null,
                reason: "",
                patient: null,
                patient_id: null,
                staff_id: null,
                type: 1,
                repeat: 1,
                occurence: 1,
                appointmentType: null,
                status_id: 1,
                bundle_id: "",
                single_bundle_id: "",
                bill_to_invoice: { id: -2, type: -2 },
                print_card: "no",
                weight: null,
                uom: 75
            },
            bundle_data: {
                bundle_id: null
            },
            metadata: {},
            title: "Check In",
            uniqueId: null,
            isProcessing: false
        };
    },
    computed: {
        isestimate() {
            return (
                this.appointment_data.bill_to_invoice &&
                this.appointment_data.bill_to_invoice.type === -2
            );
        },
        form_dirty() {
            return this.isProcessing;
        },
        isCardConnect() {
            return _.get(
                this.checkout_data,
                "payment_type_object.name",
                ""
            ).includes("CardConnect");
        }
    },
    created() {
        let self = this;
        this.$on("change-page", page => {
            self.page = page;
        });
        self.$root.$on(
            "stripe-reset-terminal-schedule-checkout",
            this.cancelStripeCollectionCheckoutModal
        );
        self.$root.$on(
            "capturing-stripe-terminal-payment-schedule-checkout",
            this.capturingStripeTerminalCheckoutModal
        );
    },
    methods: {
        cancelStripeCollectionCheckoutModal(stripeTerminal) {
            this.stripeTerminal = stripeTerminal;
        },
        capturingStripeTerminalCheckoutModal() {
            this.stripeTerminal = null;
            this.cancelling = false;
        },
        resetStripeTerminal() {
            // this.stripeTerminal.cancelCollectPaymentMethod();
            this.cancelling = true;
            this._cancelStripeTerminal(this.stripeTerminal);
            this.stripeTerminal = null;
        },
        open(id) {
            _.assign(this.$data, this.$options.data());
            _.assign(this.$data.client_data, this.$options.data().client_data);
            this.open_time = moment().tz(this._timeZone);
            this.page = "checkout";
            this.checkout_data.checkout_uid = this.uniqid();
            this.checkout_data.checkout_date = this.open_time;
            this.getCiCheckOut(id);
            this._getPaymentTypes(this.checkout_data);
            this._getTerminals(this.checkout_data);
            this.getAppointmentData(id);
            this.$refs.checkOutModal.show();
        },
        async save(checkout_data) {
            this.loading = true;
            this.saving = true;
            this.cancelling = false;
            this.isProcessing = true;
            if (!window.paymentProcessingBanner) {
                this.showPaymentProcessingMessage();
            }

            let promise;

            if (this.page == "checkout") {
                promise = this.$refs.checkoutForm.$validator.validateAll();
            } else {
                promise = Promise.resolve(true); // -- empty promise
            }

            try {
                const result = await promise;

                if (!result) {
                    this.loading = false;
                    this.saving = false;
                    this.isProcessing = false;
                    this.closePaymentProcessingMessage();
                    return;
                }

                let params = _.merge(
                    {},
                    checkout_data,
                    this.$refs.checkoutForm.getParams()
                );
                params.open_time = this.open_time;
                params.unique_id = this.uniqueId;

                $(window).on("beforeunload", function () {
                    return "Are you sure you want to leave?";
                });

                $(window).on("unload", function () {
                    $(window).off("beforeunload");
                });
                if (params.terminal && params.is_stripe_terminal) {
                    let res = await this._saveStatusStripeTerminal(params);
                    if (res && res.state === 1) {
                        throw new Error(res.message);
                    }
                    // continue to, see -> registerSocketHandling()
                } else if (params.is_stripe_keyed_in) {
                    $(window).off("beforeunload");
                    self.saving = false;
                    self.loading = false;
                    self.cancelling = false;
                } else {
                    let { response } = await this._saveStatus(params);

                    if (response && response.state == 0) {
                        if (response.document_uri) {
                            _.map(response.document_uri, document => {
                                this._redirect(document, true);
                            });
                        }
                        this.$refs.checkOutModal.hide();
                        this.$parent.refetch();

                        if (response.is_partial) {
                            this._message(response.message, "warning");
                        } else {
                            this._message(response.message);
                        }

                        // Emit socket to refresh census
                        const payload = {
                            appointmentDate: this.appointment_data?.start.unix(),
                            appointmentId: this.appointment_data?.id,
                            instanceId: this.instanceId
                        };

                        this.refreshCensus(payload);

                        if (
                            parseFloat(params.payment_amount) > 0 &&
                            params.status_id === 7 &&
                            Array.isArray(params.invoices) &&
                            params.invoices.length > 0
                        ) {
                            this.emitSocketInvoicePaid(params.invoices);
                        }
                    } else {
                        this._message(response.message, "warning");
                        this.loading = false;
                        this.isProcessing = false;
                        this.closePaymentProcessingMessage();
                    }

                    $(window).off("beforeunload");
                    this.closePaymentProcessingMessage();
                    this.isProcessing = false;
                    this.saving = false;
                    this.cancelling = false;
                }
            } catch (err) {
                $(window).off("beforeunload");
                this._message(err.message, "warning");
                this.saving = false;
                this.loading = false;
                this.isProcessing = false;
                this.closePaymentProcessingMessage();
                this.cancelling = false;
            }
        },
        /**
         * At the time of writing this function, it is only applicable to Stripe payments (Terminal).
         * This function may be used by other payment types in the future.
         */
        registerSocketHandling() {
            let self = this;

            this.$socket.client.on("v-broadcast-all", params => {
                self._socketPostPayment({
                    params: params,
                    uniqueId: this.uniqueId,
                    onSuccess() {
                        self.$refs.checkOutModal.hide();
                        self.$parent.refetch();

                        // Emit socket to refresh census
                        const payload = {
                            appointmentDate: self.appointment_data?.start.unix(),
                            appointmentId: self.appointment_data?.id,
                            instanceId: self.instanceId
                        };

                        self.refreshCensus(payload);

                        self._message(
                            "Appointment successfully checked out. Payment has been saved."
                        );
                        window.removeEventListener("beforeunload", null);
                    },
                    onError(msg) {
                        window.removeEventListener("beforeunload", null);
                        self._message(msg, "warning");
                        self.saving = false;
                        self.loading = false;
                        self.cancelling = false;
                    }
                });
            });
        },
        unregisterSocketHandling() {
            this.$socket.client.off("v-broadcast-all");
        },
        async saveAcssDebitPayment() {
            let self = this;
            let post = null;
            self.loading = true;
            self.saving = true;
            let checkout_data = self.checkout_data;

            let checkoutParams = self.$refs.checkoutForm.getParams();
            self.checkout_data.invoice_ids = checkoutParams.invoices;

            let valid = await self.$validator.validateAll();

            if (valid) {
                post = {
                    fm_credit_card_client_id: checkout_data.client_id,
                    fm_credit_card_payment_amount: checkout_data.payment_amount,
                    fm_credit_card_payment_type:
                        checkout_data.payment_type_object.name,
                    fm_credit_card_payment_type_id: checkout_data.payment_type,
                    fm_credit_card_track1: "",
                    fm_credit_card_payment_method_id: "",
                    fm_credit_card_processor:
                        checkout_data.credit_card_processor,
                    fm_credit_card_name_on_card:
                        checkout_data.credit_card_name_on_card,
                    fm_credit_card_card_number:
                        checkout_data.credit_card_card_number,
                    fm_credit_card_expiry_month:
                        checkout_data.credit_card_expiry_month,
                    fm_credit_card_expiry_year:
                        checkout_data.credit_card_expiry_year,
                    fm_credit_card_ccv: checkout_data.credit_card_ccv,
                    fm_credit_card_output: $("#fm_credit_card_output").val(),
                    fm_credit_card_name: $("#fm_credit_card_name").val(),
                    save_card: 0
                };

                if (checkoutParams.is_stripe_acss) {
                    // load iframe for acss debit stripe
                    valid = false;

                    let params = _.merge(
                        {},
                        self.checkout_data,
                        this.$refs.checkoutForm.getParams()
                    );

                    self.metadata = params;
                    let input_metadata = self._generateMetadata(
                        {
                            ...self.metadata,
                            userId: self.$root.currentActor.id
                        },
                        self.metadata.is_census
                    );

                    await self.$http
                        .post(
                            process.env.BARRAMUNDI + "payment/stripe/secret",
                            {
                                amount: checkout_data.payment_amount,
                                client_id: checkout_data.client_id,
                                trans_type: "acss_debit",
                                input_metadata: input_metadata,
                                business_id: checkout_data.business_id
                            }
                        )
                        .then(async function (response) {
                            if (response.data.response.client_secret) {
                                let clientSecret =
                                    response.data.response.client_secret;
                                // eslint-disable-next-line no-undef
                                let stripe = Stripe(
                                    _.get(
                                        self,
                                        "$root.cc_extension.STRIPE_PUBLIC_KEY",
                                        ""
                                    ),
                                    {
                                        stripeAccount: _.get(
                                            self,
                                            "$root.cc_extension.STRIPE_ACCOUNT_ID",
                                            ""
                                        )
                                    }
                                );

                                let res = await stripe
                                    .confirmAcssDebitPayment(clientSecret, {
                                        payment_method: {
                                            billing_details: {
                                                name:
                                                    self.appointment_data.client
                                                        .label,
                                                email:
                                                    self.appointment_data.client
                                                        .email
                                            }
                                        }
                                    })
                                    .then(async function (result) {
                                        if (result.error) {
                                            self.loading = false;
                                            self._message(
                                                result.error.code ==
                                                    "parameter_missing"
                                                    ? "Requires client email address"
                                                    : result.error.message,
                                                "danger"
                                            );
                                            return;
                                        }
                                    });
                            }
                        });
                    //
                }
            } else {
                return false;
            }
        },
        async saveCreditCard() {
            let self = this;
            let post = null;
            self.loading = true;
            self.saving = true;
            this.isProcessing = true;
            this.showPaymentProcessingMessage();

            let checkoutParams = self.$refs.checkoutForm.getParams();
            self.checkout_data.invoice_ids = checkoutParams.invoices;

            const save_card = self.checkout_data.save_card == 1;
            if (
                save_card &&
                this.checkout_data.credit_card_processor === "STRIPE"
            ) {
                try {
                    let updateMetadata = await PaymentService.updateSaveCard(
                        self.checkout_data.stripe.clientSecret.split(
                            "_secret"
                        )[0],
                        {
                            input_metadata: {
                                save_card: save_card
                            }
                        }
                    );
                    if (updateMetadata.code !== 200) {
                        self._message("Failed to save card", "danger");
                        self.loading = false;
                        self.saving = false;
                        return;
                    }
                } catch (error) {
                    self._message("Failed to save card", "danger");
                    self.loading = false;
                    self.saving = false;
                    this.isProcessing = false;
                    this.closePaymentProcessingMessage();
                    return;
                }
            }

            return self.$refs.payment
                .pay_checkout(self.checkout_data)
                .then(response => {
                    if (response.capture) {
                        return;
                        // wait for socket trigger from backend
                    }
                    if (response && response.state != 1) {
                        self.save(response);
                    } else {
                        self.loading = false;
                        this.isProcessing = false;
                        this.closePaymentProcessingMessage();
                        return response;
                    }
                })
                .finally(() => {
                    // self.loading = false;
                });
        },
        shown() {
            // reset all data
            this.page = "checkout";
            this.uniqueId = this.uniqid();
            this.checkout_data.uniqueId = this.uniqueId;
            this.checkout_data.is_census = true;
            this.registerSocketHandling();
        },
        next() {
            let self = this;
            if (self.page === "checkout") {
                self.$refs.checkoutForm.$validator
                    .validateAll()
                    .then(result => {
                        if (result) {
                            self.checkout_data.show_payment_form = 1;
                            self.checkout_data.credit_card_name_on_card = _.get(
                                self,
                                "appointment_data.client.label"
                            );
                            self.page = "payment";

                            let params = _.merge(
                                {},
                                self.checkout_data,
                                this.$refs.checkoutForm.getParams()
                            );

                            self.metadata = params;

                            if (
                                self.checkout_data.credit_card_processor ===
                                    "CCONNECT" &&
                                !self.checkout_data.cc_iframe_load
                            ) {
                                self.loading = true;
                            }
                        }
                    });
            }
        },
        showCreditCardDialog() {
            let self = this;
            if (self.page == "checkout") {
                self.$refs.checkoutForm.$validator
                    .validateAll()
                    .then(result => {
                        if (result) {
                            self.checkout_data.show_payment_form = 0;
                            self.page = "payment";
                        }
                    });
            }
        },
        back() {
            if (this.page == "payment") {
                this.page = "checkout";
            }
        },
        close() {
            this.unregisterSocketHandling();
        },
        getAppointmentData(id) {
            let self = this;
            return this.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment/" + id)
                .then(function (response) {
                    self.appointment_data = _.merge(
                        self.appointment_data,
                        response.data.response.resources
                    );
                    self.appointment_data.start = moment(
                        self.appointment_data.start
                    );
                    self.appointment_data.end = moment(
                        self.appointment_data.end
                    );
                    self.$nextTick(() => {
                        self.$refs.checkoutForm.$validator.reset();
                    });
                });
        },
        getCiCheckOut(appointment_id) {
            let self = this;
            self.loading = true;
            this.$http
                .get(
                    process.env.APPS +
                        "index.php/schedule/census/prepareCheckoutData?id=" +
                        appointment_id
                )
                .then(function (response) {
                    self.checkout_data = _.merge(
                        self.checkout_data,
                        response.data.form_data
                    );

                    if (self.checkout_data.invoices) {
                        self.checkout_data.invoicesList = Object.entries(
                            self.checkout_data.invoices
                        ).map(([id, label]) => ({
                            id,
                            label,
                            is_invoice: true
                        }));
                        self.checkout_data.invoices = _.clone(
                            self.checkout_data.invoicesList
                        );
                    }
                    if (self.checkout_data.credits) {
                        self.checkout_data.creditsList = Object.entries(
                            self.checkout_data.credits
                        ).map(([id, label]) => ({ id, label }));
                        self.checkout_data.credits = _.clone(
                            self.checkout_data.creditsList
                        );
                    }
                    if (self.checkout_data.documents) {
                        self.checkout_data.documentsList = Object.entries(
                            self.checkout_data.documents
                        ).map(([id, label]) => ({ id, label }));

                        const params = {
                            dataDefaultDocuments:
                                self.checkout_data.default_documents,
                            dataDocumentList: self.checkout_data.documentsList,
                            dataDocuments: self.checkout_data.documents
                        };

                        self.checkout_data.documents = self.checkoutDefaultDocuments(
                            params
                        );
                    }
                })
                .finally(() => {
                    self.loading = false;
                });
        },
        verifyGravityPayment() {
            let self = this;
            var gravityData = {
                uniqueTransId: self.checkout_data.uniqueTransId,
                externalTransactionId: self.checkout_data.externalTransactionId
            };

            self.$http
                .post(process.env.BARRAMUNDI + "payment/verify-transaction", {
                    gravityData: gravityData
                })
                .then(function (response) {
                    if (response.data.response.success) {
                        self.saveCreditCard();
                    } else {
                        self._message(
                            "Payment failed. Please try again.",
                            "danger"
                        );
                        self.$refs.payment.callGravityIFrame(
                            self.checkout_data.gravity_button
                        );
                    }
                });
        },
        cancelOperation() {
            let self = this;
            self.cancelling = true;

            self.$http
                .post(process.env.BARRAMUNDI + "payment/cancel-operation", {
                    hsn: self.checkout_data.terminal,
                    payment_type: "Credit Card On Terminal (Gravity)"
                })
                .then(function (response) {
                    /*if (response.data.response.message.code == 200) {
                        self._message(
                            response.data.response.message.description
                        );
                    } else {
                        self._message(
                            response.data.response.message.description,
                            "danger"
                        );
                    }*/

                    self.loading = false;
                    self.saving = false;
                    self.cancelling = false;
                });
        },
        disabledSaveButton(isDisabled) {
            let self = this;
            if (isDisabled) {
                self.isDisabledButton = true;
            } else {
                self.isDisabledButton = false;
            }
        }
    }
};
</script>
